import * as React from 'react';

interface TrendIndicatorProps {
  change: number;
  size?: 'sm' | 'md';
}

const TrendIndicator: React.FC<TrendIndicatorProps> = ({ change, size = 'md' }) => {
  const fontSize = size === 'sm' ? '0.8rem' : '0.95rem';

  if (change > 0) {
    return (
      <span style={{ color: '#198754', fontSize, fontWeight: 500 }}>
        &#9650; +{change}%
      </span>
    );
  }
  if (change < 0) {
    return (
      <span style={{ color: '#dc3545', fontSize, fontWeight: 500 }}>
        &#9660; {change}%
      </span>
    );
  }
  return (
    <span style={{ color: '#6c757d', fontSize }}>
      &#8212; 0%
    </span>
  );
};

TrendIndicator.displayName = 'TrendIndicator';
export default TrendIndicator;
